import { render, staticRenderFns } from "./UICookieSettingsBtn.vue?vue&type=template&id=44f75327&scoped=true&"
import script from "./UICookieSettingsBtn.vue?vue&type=script&lang=ts&"
export * from "./UICookieSettingsBtn.vue?vue&type=script&lang=ts&"
import style0 from "./UICookieSettingsBtn.vue?vue&type=style&index=0&id=44f75327&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f75327",
  null
  
)

export default component.exports